import React, { useState, useContext, useEffect, Fragment } from "react";
import {
  Collapse,
  List,
  ListItem,
  ListItemText,
  Divider,
  FormControl,
  Select,
  InputLabel,
} from "@material-ui/core";
import { FaChevronUp, FaChevronDown, FaChevronRight } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";
import { LangContext } from "../../Context/Langcontext";
import useReactRouter from "use-react-router";
// import { UserContext } from "../../Context/UserContext";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    backgroundColor: "#e2e2e2",
    paddingTop: "unset",
    paddingBottom: "unset",
  },
  detailroot: {
    width: "100%",
    backgroundColor: "#efefef",
  },
  nested: {
    paddingLeft: theme.spacing(4),
  },
  menu: {
    fontWeight: 200,
  },
  divroot: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  sticky: {},
  select: {
    "& .MuiSelect-icon": {
      color: "#E16733",
      fontSize: "2.25rem",
      top: "calc(50% - 18px)",
    },
    "& .MuiSelect-root": {
      padding: "0.8rem",
    },
    borderRadius: 8,
    fontWeight: 200,
  },
  label: {
    transform: "translate(16px, 14px) scale(1)",
    fontWeight: 200,
  },
}));

const ContentList = () => {
  const classes = useStyles();
  // const [docopen, setDocopen] = useState([]);
  // const [detailopen, setDetailopen] = useState([]);
  // const [select, setSelect] = useState(1);
  // const [selectHead, setSelectHead] = useState(1);
  // const userContext = useContext(UserContext);
  const [version, setVersion] = useState("version 1.0");
  const langContext = useContext(LangContext);
  const lang = langContext.lang.data;
  const { location } = useReactRouter();
  const [stateOpen, setStateOpen] = useState({
    one: false,
    two: false,
    three: false,
    four: false,
    five: false,
    six: false,
    seven: false,
    eight: false,
  });

  const docintro = [
    {
      title: "Introduction to MEA API",
      section: "intro",
    },
    { title: "API Key", section: "accesstoken" },
    // { title: `${lang.API} ${lang.Versioning}`, section: "api" },
    // { title: lang.RateLimits, section: "ratelimit" },
    { title: lang.ResponseMessages, section: "response" },
  ];

  // const doclandbase = [
  //   {
  //     title: lang.LandmarkPoint,

  //     section: "landmark_point",
  //   },
  //   {
  //     title: lang.DistrictPoly,

  //     section: "district_poly",
  //   },
  //   {
  //     title: lang.LandmarkLine,

  //     section: "landmark_line",
  //   },
  //   {
  //     title: lang.CenterLine,

  //     section: "center_lines",
  //   },
  //   {
  //     title: lang.RoadEdge,

  //     section: "road_edge",
  //   },
  //   { title: lang.Building, section: "Building" },
  //   {
  //     title: lang.BuildingLine,

  //     section: "building_line",
  //   },
  //   { title: lang.Hydrology, section: "hydrology" },
  // ];

  // const docelectric = [
  //   {
  //     title: lang.Capacitor,
  //     section: "capacitor",
  //   },
  //   {
  //     title: lang.cctv,
  //     section: "cctv",
  //   },
  //   {
  //     title: lang.DuctBank,
  //     section: "duct_bank",
  //   },
  //   {
  //     title: lang.FiberOpticCable,
  //     section: "fiber_optic_cable",
  //   },
  //   {
  //     title: lang.Fuse,
  //     section: "fuse",
  //   },
  //   {
  //     title: lang.Ground,
  //     section: "ground",
  //   },
  //   {
  //     title: lang.GroundMeter,
  //     section: "ground_meter",
  //   },
  //   {
  //     title: lang.HighTensionMeter,
  //     section: "high_tension_meter",
  //   },
  //   {
  //     title: lang.InlineEquipment,
  //     section: "inline_equipment",
  //   },
  //   {
  //     title: lang.LightningArrestor,
  //     section: "lightning_arrestor",
  //   },
  //   {
  //     title: lang.LowVoltageMeter,
  //     section: "low_voltage_meter",
  //   },
  //   {
  //     title: lang.Manhole,
  //     section: "manholes",
  //   },
  //   {
  //     title: lang.Meterline,
  //     section: "meter_line",
  //   },
  //   {
  //     title: lang.Meterlink,
  //     section: "meter_link",
  //   },
  //   {
  //     title: lang.OverheadHighVoltageConductor,
  //     section: "ohhv_conductor",
  //   },
  //   {
  //     title: lang.OverheadLowVoltageConductor,
  //     section: "ohlv_conductor",
  //   },
  //   {
  //     title: lang.OverheadLowVoltageConductorUnder,
  //     section: "ohlv_conductor_under_building",
  //   },
  //   {
  //     title: lang.OverheadMediumVoltageConductor,
  //     section: "ohmv_conductor",
  //   },
  //   {
  //     title: lang.OverheadStreetlightVoltageConductor,
  //     section: "ohsl_conductor",
  //   },
  //   {
  //     title: lang.Pole,
  //     section: "pole",
  //   },
  //   {
  //     title: lang.SpanGuy,
  //     section: "span_guys",
  //   },
  //   {
  //     title: lang.Splice,
  //     section: "splice",
  //   },
  //   {
  //     title: lang.Streetlight,
  //     section: "streetlight",
  //   },
  //   {
  //     title: lang.StreetlightControl,
  //     section: "streetlight_control",
  //   },
  //   {
  //     title: lang.Switche,
  //     section: "switch",
  //   },
  //   {
  //     title: lang.Transformer,
  //     section: "transformer",
  //   },
  //   {
  //     title: lang.UndergroundHighVoltageConductor,
  //     section: "ughv_conductor",
  //   },
  //   {
  //     title: lang.UndergroundLowVoltageConductor,
  //     section: "uglv_conductor",
  //   },
  //   {
  //     title: lang.UndergroundMediumVoltageConductor,
  //     section: "ugmv_conductor",
  //   },
  //   {
  //     title: lang.UndergroundStreetlightVoltageConductor,
  //     section: "ugsl_conductor",
  //   },
  //   {
  //     title: lang.Streetlightinlineequipment,
  //     section: "sl_inline_equipment",
  //   },
  //   {
  //     title: lang.Circuitbreaker,
  //     section: "circuit_breaker",
  //   },
  // ];

  const goHash = (rs) => {
    let a = document.createElement("a");
    a.href = `#${rs.section}`;
    a.click();

    let element = document.getElementById(`${rs.section}`);
    let offTop = element.offsetTop;
    setTimeout(() => {
      window.scrollTo({
        top: offTop - 100,
        left: 0,
        behavior: "smooth",
      });
    }, 300);
  };

  useEffect(() => {
    let intro = docintro.find((rs) => {
      return rs.section === location.hash.split("#")[1];
    });

    if (intro !== undefined) {
      setStateOpen({
        ...stateOpen,
        one: true,
        two: false,
        three: false,
        five: false,
        eight: false,
        four: false,
      });
    } else if (location.hash.split("#")[1] === "mea_data_service") {
      setStateOpen({
        ...stateOpen,
        one: false,
        two: true,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: false,
        eight: false,
      });
    } else if (location.hash.split("#")[1] === "mea_map_service") {
      setStateOpen({
        ...stateOpen,
        one: false,
        two: false,
        three: false,
        four: false,
        five: true,
        six: false,
        seven: false,
        eight: false,
      });
    } else if (location.hash.split("#")[1] === "scs") {
      setStateOpen({
        ...stateOpen,
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: true,
        seven: false,
        eight: false,
      });
    } else if (location.hash.split("#")[1] === "address") {
      setStateOpen({
        ...stateOpen,
        one: false,
        two: false,
        three: false,
        four: false,
        five: false,
        six: false,
        seven: true,
        eight: false,
      });
    }
  }, [location]);
  //address
  return (
    <div
      className={classes.sticky}
      style={{ width: "100%", textAlign: "center" }}
    >
      <FormControl
        variant="outlined"
        fullWidth
        style={{ marginTop: "1rem", marginBottom: "1rem", width: "95%" }}
      >
        <InputLabel
          id="demo-simple-select-outlined-label"
          className={classes.label}
        >
          {lang.ApiKey}
        </InputLabel>
        <Select
          labelId="demo-api-key"
          id="demo-customized-api"
          label="API Key"
          className={classes.select}
          native
          value={version}
          onChange={(e) => {
            setVersion(e.target.value);
          }}
        >
          <option value={10}>version 1.0</option>
        </Select>
      </FormControl>
      <List component="nav" className={classes.root}>
        <div>
          <ListItem
            style={{ padding: "1rem" }}
            button
            onClick={() => {
              setStateOpen({
                ...stateOpen,
                one: !stateOpen.one,
                two: false,
                three: false,
                four: false,
                five: false,
                six: false,
                seven: false,
                eight: false,
              });
            }}
          >
            <ListItemText
              disableTypography
              primary={lang.Introduction}
              style={{
                color: stateOpen.one ? "#E16733" : "#595A5A",
                fontWeight: stateOpen.one ? 400 : 200,
                fontSize: "0.8rem",
              }}
            />
            {stateOpen.one ? (
              <FaChevronUp
                style={{
                  color: stateOpen.one ? "#E16733" : "#595A5A",
                }}
                size={12}
              />
            ) : (
              <FaChevronDown
                style={{
                  color: stateOpen.one ? "#E16733" : "#595A5A",
                }}
                size={12}
              />
            )}
          </ListItem>
        </div>
        {stateOpen.one ? null : (
          <Divider
            variant="middle"
            style={{
              backgroundColor: "#b4b4b4",
            }}
          />
        )}

        <Collapse in={stateOpen.one} timeout="auto" unmountOnExit>
          <List component="div" className={classes.detailroot}>
            <div className={classes.divroot}>
              <div style={{ width: "95%", height: "95%" }}>
                {docintro.map((res, index) => {
                  return (
                    <div key={res.title}>
                      <ListItem
                        button
                        style={{ padding: "0.5rem" }}
                        onClick={() => {
                          goHash(res);
                        }}
                      >
                        <ListItemText
                          disableTypography
                          primary={res.title}
                          style={{
                            color:
                              res.section === location.hash.split("#")[1]
                                ? "#E16733"
                                : "#595A5A",
                            fontWeight:
                              res.section === location.hash.split("#")[1]
                                ? 400
                                : 200,
                            fontSize: "0.8rem",
                          }}
                        />
                      </ListItem>
                    </div>
                  );
                })}
              </div>
            </div>
          </List>
        </Collapse>

        <div>
          <ListItem
            style={{ padding: "1rem" }}
            button
            onClick={() => {
              setStateOpen({
                ...stateOpen,
                one: false,
                two: !stateOpen.two,
                three: false,
                four: false,
                five: false,
                six: false,
                seven: false,
                eight: false,
              });

              goHash({ section: "mea_data_service" });
            }}
          >
            <ListItemText
              disableTypography
              primary={lang.DataService}
              style={{
                color: stateOpen.two ? "#E16733" : "#595A5A",
                fontWeight: stateOpen.two ? 400 : 200,
                fontSize: "0.8rem",
              }}
            />
            {stateOpen.two ? (
              <FaChevronRight
                style={{
                  color: stateOpen.two ? "#E16733" : "#595A5A",
                }}
                size={12}
              />
            ) : (
              <FaChevronDown
                style={{
                  color: stateOpen.two ? "#E16733" : "#595A5A",
                }}
                size={12}
              />
            )}
          </ListItem>
        </div>
        {/* {stateOpen.two ? null : ( */}
        <Divider
          variant="middle"
          style={{
            backgroundColor: "#b4b4b4",
          }}
        />
        {/* )} */}

        <div>
          <ListItem
            style={{ padding: "1rem" }}
            button
            onClick={() => {
              setStateOpen({
                ...stateOpen,
                one: false,
                two: false,
                three: false,
                four: false,
                five: !stateOpen.five,
                six: false,
                seven: false,
                eight: false,
              });
              goHash({ section: "mea_map_service" });
            }}
          >
            <ListItemText
              disableTypography
              primary={lang.MapService}
              style={{
                color: stateOpen.five ? "#E16733" : "#595A5A",
                fontWeight: stateOpen.five ? 400 : 200,
                fontSize: "0.8rem",
              }}
            />
            {stateOpen.five ? (
              <FaChevronRight
                style={{
                  color:
                    location.hash.split("#")[1] === "mea_map_service"
                      ? "#E16733"
                      : "#595A5A",
                }}
                size={12}
              />
            ) : (
              <FaChevronDown
                style={{
                  color:
                    location.hash.split("#")[1] === "mea_map_service"
                      ? "#E16733"
                      : "#595A5A",
                }}
                size={12}
              />
            )}
          </ListItem>
        </div>
        <Divider
          variant="middle"
          style={{
            backgroundColor: "#b4b4b4",
          }}
        />

        {localStorage.getItem("token") ? (
          !localStorage.getItem("mea") &&
          localStorage.getItem("role") !== "admin" &&
          localStorage.getItem("role") !== "root" ? null : (
            <Fragment>
              <div>
                <ListItem
                  style={{ padding: "1rem" }}
                  button
                  onClick={() => {
                    setStateOpen({
                      ...stateOpen,
                      one: false,
                      two: false,
                      three: false,
                      four: false,
                      five: false,
                      six: !stateOpen.six,
                      seven: false,
                      eight: false,
                    });
                    goHash({ section: "scs" });
                  }}
                >
                  <ListItemText
                    disableTypography
                    primary={"SCS"}
                    style={{
                      color: stateOpen.six ? "#E16733" : "#595A5A",
                      fontWeight: stateOpen.six ? 400 : 200,
                      fontSize: "0.8rem",
                    }}
                  />
                  {stateOpen.six ? (
                    <FaChevronRight
                      style={{
                        color:
                          location.hash.split("#")[1] === "scs"
                            ? "#E16733"
                            : "#595A5A",
                      }}
                      size={12}
                    />
                  ) : (
                    <FaChevronDown
                      style={{
                        color:
                          location.hash.split("#")[1] === "scs"
                            ? "#E16733"
                            : "#595A5A",
                      }}
                      size={12}
                    />
                  )}
                </ListItem>
              </div>
              <Divider
                variant="middle"
                style={{
                  backgroundColor: "#b4b4b4",
                }}
              />
            </Fragment>
          )
        ) : null}

        <div>
          <ListItem
            style={{ padding: "1rem" }}
            button
            onClick={() => {
              setStateOpen({
                ...stateOpen,
                one: false,
                two: false,
                three: false,
                four: false,
                five: false,
                six: false,
                seven: !stateOpen.seven,
                eight: false,
              });
              goHash({ section: "address" });
            }}
          >
            <ListItemText
              disableTypography
              primary={lang.Address}
              style={{
                color: stateOpen.seven ? "#E16733" : "#595A5A",
                fontWeight: stateOpen.seven ? 400 : 200,
                fontSize: "0.8rem",
              }}
            />
            {stateOpen.five ? (
              <FaChevronRight
                style={{
                  color:
                    location.hash.split("#")[1] === "address"
                      ? "#E16733"
                      : "#595A5A",
                }}
                size={12}
              />
            ) : (
              <FaChevronDown
                style={{
                  color:
                    location.hash.split("#")[1] === "address"
                      ? "#E16733"
                      : "#595A5A",
                }}
                size={12}
              />
            )}
          </ListItem>
        </div>
      </List>
    </div>
  );
};

export default ContentList;
